export enum API {
   //Base URLs
   // BASE_URL_DEV = 'http://10.76.166.17:8080/',
   BASE_URL_DEV = 'https://dev-capi.centili.com/',
   BASE_URL_PRODUCTION = 'https://capi.centili.com/',
   REACT_APP_ENV = 'REACT_APP_ENV',
}
